import {FC} from 'react';
import {formatCurrency} from '../utils';
import styles from '../Dashboard.module.scss';

interface TooltipEntry {
  name?: string;
  value?: number | string;
  color?: string;
  dataKey?: string;
  payload?: {fill?: string};
}

interface Props {
  active?: boolean;
  label?: string | number;
  payload?: TooltipEntry[];
}

const ChartTooltip: FC<Props> = ({active, label, payload}) => {
  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className={styles.tooltip}>
      {label ? <div className={styles.tooltipTitle}>{label}</div> : null}
      {payload.map((entry, index) => (
        <div key={entry.dataKey ?? entry.name ?? index} className={styles.tooltipRow}>
          <span
            className={styles.tooltipDot}
            style={{background: entry.color ?? entry.payload?.fill ?? 'var(--tooltip-text-muted)'}}
          />
          <span className={styles.tooltipName}>{entry.name}</span>
          <span className={styles.tooltipValue}>
            {formatCurrency(Number(entry.value))}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ChartTooltip;
